/* eslint-disable */
(function($) {
  'use strict';

  // For mobile tooltips
  var touching;
  var touchMoveThreshold = 10;
  var touchX;
  var touchY;

  // Show callout on click
  $(document)
    // Blue callouts, triggered by click
    .on('click', '[data-callout]', function(e) {
      $(this).zrCallout('show');
    })
    // Hoverable callout
    .on('mouseover focus', '[data-callout][data-hoverable="true"]', function(e) {
      if ( touching ) {
        touching = false;
        return true;
      }

      var $this = $(this);
      clearTimeout($this.data('horverableHideTimeout'));

      $(this).zrCallout('show');
    })
    .on('mouseout blur', '[data-callout][data-hoverable="true"]', function(e) {
      var $this = $(this);

      clearTimeout($this.data('horverableHideTimeout'));
      $this.data('horverableHideTimeout', setTimeout(function() {
        $this.zrCallout('hide', true);
      }, 100));
    })
    .on('mouseover focusin', '.zrCallout[data-hoverable="true"]', function(e) {
      var callouts = $(this).data('callout-object-callouts');

      for ( var i = 0, l = callouts.length, callout; i < l; i++) {
        callout = callouts[i];
        clearTimeout(callout.$el.data('horverableHideTimeout'));
      }
    })
    .on('mouseout blur', '.zrCallout[data-hoverable="true"]', function(e) {
      var callouts = $(this).data('callout-object-callouts');

      for ( var i = 0, l = callouts.length, callout; i < l; i++) {
        callout = callouts[i];
        (function($el) {
          clearTimeout($el.data('horverableHideTimeout'));
          $el.data('horverableHideTimeout', setTimeout(function() {
            $el.zrCallout('hide', true);
          }, 100));
        })(callout.$el);
      }
    })
    // Black tooltips, triggered by hover, focus
    .on('mouseover focus', '[data-callout="tooltip"]', function(e) {
      if ( touching ) {
        touching = false;
        return true;
      }

      $(this).zrCallout('show');
    })
    .on('mouseout blur', '[data-callout="tooltip"]', function(e) {
      $(this).zrCallout('hide', true);
    })
    // Open/close toggle on mobile
    .on('touchstart', '[data-callout="tooltip"]', function(e) {
      scrolled = false;
      // Keep track of where we touched so we can avoid showing tooltips on drag
      touchX = e.originalEvent.touches[0].pageX;
      touchY = e.originalEvent.touches[0].pageY;
    })
    .on('touchend', '[data-callout="tooltip"]', function(e) {
      var mouseX = e.originalEvent.changedTouches[0].pageX;
      var mouseY = e.originalEvent.changedTouches[0].pageY;
      var touchMoveDistance = Math.floor(Math.sqrt(Math.pow(mouseX - touchX, 2) + Math.pow(mouseY - touchY, 2)));

      if ( !scrolled && touchMoveDistance < touchMoveThreshold ) {
        touching = true;
        $openEl = $(this);
        $openEl.zrCallout('toggle');
      }
    })
    ;

  // Don't open if we start touching and scroll
  var scrolled = false;

  // Used for mobile to know if tooltip is open
  var $openEl = null;

  $(window).on('scroll', function() {
    scrolled = true;
    // If tooltip is open on scroll, close
    if ($openEl) {
      $openEl.zrCallout('hide');
    }
  });

  // Hide callout when a modal opens so it does not overlap the modal
  $(window).on('show.bs.modal cbox_open', function() {
    $('[data-callout]').zrCallout('hide');
  });

  // Auto show placements
  $('[data-callout][data-show="true"]').zrCallout();

}(window.Zepto || window.jQuery || window.$));
